/* eslint-disable react/jsx-sort-props */
import React from 'react';
import { usePageTitle, useSiteConfig } from '../../config';
import { styled } from '@mui/material/styles';
import '../../../node_modules/@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import { useTranslate } from '@im/react-localization';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

type Props = {
  children: JSX.Element;
};

export const LoginLayoutX4EC = (props: Readonly<Props>) => {
  const { children } = props;
  const translateStr = useTranslate();
  const copyrightContent = translateStr('OktaWidget.Copyright');
  const whatYearIsItNow = new Date().getFullYear().toString();
  const { updatePageTitle } = usePageTitle();
  const { storefrontInfo } = useSiteConfig();

  updatePageTitle(translateStr('Title.Login'));

  return (
    <Root columnSpacing={8} container>
      <Grid
        alignItems="center"
        border="1px soild cyan"
        display="flex"
        flexDirection="column"
        item
        justifyContent="space-between"
        xs={12}
        md={6}
        sx={{
          pb: 8,
          pt: 8,
        }}
      >
        <Box height={36} width="100%">
          <img
            alt={`${storefrontInfo?.displayName} logo`}
            height="36"
            src={storefrontInfo?.logo ?? '/xshared/assets/img/logo-ingram-blue'}
            width="auto"
          />
        </Box>
        <Box flex={1}>
          <Typography variant="display-sm-semibold">Welcome back</Typography>
          {children}
        </Box>
        <Box alignItems="flex-end" display="flex" height={144} width="100%">
          <Typography
            color={(theme) => theme.palette.gray[600]}
            variant="text-sm-regular"
          >
            {copyrightContent.replace(/\{\{year\}\}/gi, whatYearIsItNow)}
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={0}
        md={6}
        sx={{
          pb: 4,
          pt: 4,
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(45deg, #194185 0%, #1570EF 100%)',
            borderRadius: '20px',
            height: '100%',
            width: '100%',
          }}
        />
      </Grid>
    </Root>
  );
};

const Root = styled(Grid)(({ theme }) => ({
  '#okta-sign-in .auth-header': {
    padding: '0',
  },
  '#okta-sign-in .beacon-container': {
    bottom: 30,
  },
  '#okta-sign-in.auth-container': {
    '.mfa-google-auth,.mfa-google-auth-30': {
      backgroundImage:
        'url(/cep/assets/okta-signin-widget/img/icons/mfa/google-ms-authenticators_sm.png)',
      backgroundSize: 'contain',
    },
  },
  '#okta-sign-in.auth-container.main-container': {
    '.auth-content': {
      padding: 'unset',
    },
    '.button-primary': {
      background: theme.palette.primary[600],
      borderColor: theme.palette.primary[600],
      borderRadius: 32,
      color: theme.palette.common.white,
      fontSize: 18,
      height: 44,
    },
    '.link': {
      ...theme.typography['text-sm-semibold'],
      color: theme.palette.primary[700],
      textDecoration: 'none',
    },
    '.o-form .infobox': {
      color: theme.palette.text.secondary,
    },
    '.o-form .input-fix': {
      border: 'unset',
      height: 40,
      input: {
        '&:-webkit-autofill': {
          WebkitBoxShadow: `0 0 0 25px ${theme.palette.common.white} inset`,
          WebkitTextFillColor: theme.palette.gray[500],
        },
        '&::selection': {
          //backgroundColor: theme.palette.common.black,
        },
        border: `1px solid ${theme.palette.gray[400]}`,
        borderRadius: 8,
      },
    },
    '.o-form-explain': {
      color: 'unset',
      textAlign: 'left',
    },
    '.o-form-fieldset': {
      '&:first-of-type': {
        marginBottom: 20,
      },
    },
    '.o-form-head': {
      ...theme.typography['text-md-regular'],
      color: theme.palette.gray[600],
      textAlign: 'left',
    },
    '.okta-form-input-field': {
      backgroundColor: 'unset',
      boxShadow: 'unset',
    },
    '.okta-form-label': {
      color: theme.palette.gray[700],
      fontWeight: 500,
      position: 'relative',
      top: -4,
      width: 'auto',
      zIndex: 1,
    },
    '.okta-sign-in-header.auth-header': {
      '.beacon-container.beacon-small': {
        display: 'none',
      },
      borderBottom: 'unset',
    },

    backgroundColor: 'transparent',
    borderColor: 'transparent',
    boxShadow: 'none',
    color: theme.palette.text.primary,
    fontFamily: 'Inter',
    // height: '100vh',
    input: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.primary,
      fontFamily: 'unset',
    },
    margin: '0',
    overflow: 'unset',
    width: 360,
  },
  '#okta-sign-in.no-beacon .auth-header': {
    paddingBottom: 'unset',
  },
}));
